import React, { FC, useState } from 'react';

import { Tabs } from 'antd';
import { useLocation,useNavigate } from 'react-router-dom';

import BalanceTab from './tabs/BalanceTab';
import BillTab from './tabs/BillTab';
import RequisitesTab from './tabs/RequisitesTab';
import WithdrawsTab from './tabs/WithdrawsTab';
import { useTypedSelector } from '../../../hooks/useTypedSelector';

const BillingPage: FC = () => {
    const { currency } = useTypedSelector((state) => state.meta);
    /** Версия списка счетов: инкремент заставляет вкладку «Счета и акты» перезапросить данные */
    const [ billsVersion, setBillsVersion ] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();
    const tabs = (currencyValue: string) => {
        const tabsArr = [
            {
                label: <span data-help-id="billing-balance">Баланс и тариф</span>,
                key: 'item-1',
                children: <BalanceTab currency={'₽'} onBillCreated={() => setBillsVersion((prev) => prev + 1)}/>,
                forceRender: true,
            },
            {
                label: <span data-help-id="billing-bills">Счета и акты</span>,
                key: 'item-2',
                children: <BillTab currency={'₽'} refreshKey={billsVersion}/>,
                forceRender: true,
            },
            {
                label: <span data-help-id="billing-withdraws">Пополнения и списания</span>,
                key: 'item-3',
                children: <WithdrawsTab currency={'₽'}/>,
                forceRender: true,
            },
            {
                label: <span data-help-id="billing-requisites">Реквизиты</span>,
                key: 'item-4',
                children: <RequisitesTab/>,
                forceRender: true,
            }
        ];
    return tabsArr;
};
    const handleTabChange = (key: string) => {
        const url = new URL(window.location.href);
        url.searchParams.set('tab', key);
        navigate(url.pathname + url.search);
    };

    const getCurrentTab = () => {
        const searchParams = new URLSearchParams(location.search);
        return searchParams.get('tab') || 'item-1';
    };

    return (
    <div data-help-id="billing-page">
      <Tabs type="card" items={tabs(currency)} activeKey={getCurrentTab()} onChange={handleTabChange} />
    </div>
    );
};

export default BillingPage;
